export default __webpack_public_path__ + "static/media/pl.680bb31c.png";